import axios from 'axios';
import normalize from 'Utils/normalizer';
import { map, omitBy, isEmpty, isNil, omit } from 'lodash';
import { apiURL } from '../helpers';
import { errorHandler } from '../utils';

type Pagination = {
  offset: number,
  limit: number
}
interface Sorting {
  sortBy: string,
  mode: "ASC" | "DESC"
}

export const fetchOrg = async (id: string) => {
  const url = apiURL('/org/fetch');

  const initFilters = {

  };

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: { filters: omitBy({ ...initFilters, _id: id }, isNil)}
    })

    console.log(response)

    return []

  }
  catch(err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchOrg(id);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}

type orgListFilters = 
{
  mohID?: string,
  parentID?: string,
  name?: string,
  code?: string,
  orgCode_OR_orgName?: string,
  orgType?: string[],
  supplierID?: string,
  active?: boolean,
  orgIDs?: string[],
  totalCount?: boolean
}

export const fetchOrgList = async (filters: orgListFilters, pagination?: Pagination, sorting?:Sorting) => {
  const url = apiURL('/org/list');

  try {
    const response = await axios({
      method: 'POST',
      url: url,
      data: omitBy({ 
        filters: {...filters, active: true}, 
        pagination, 
        sorting }, isNil)
    })

    return response

  }
  catch(err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchOrgList(filters, pagination, sorting);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack }};
    }
    else {
      console.log(err.message)
      return { error: { message: err.message }};
    }
  }
}